import { appConfig } from "src/config";
import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";
import { isEU } from "src/utils/userSegment";

declare const window: Window & {
  OneTrust?: {
    OnConsentChanged(
      callback: (event: { detail: LibCategories[] }) => void
    ): void;
  };
  OnetrustActiveGroups?: string;
};

let resolveFullyLoaded: () => void;
const fullyLoaded = new Promise<void>((_resolve) => {
  resolveFullyLoaded = _resolve;
});

(window as any).OptanonWrapper = function OptanonWrapper() {
  resolveFullyLoaded();
};

export async function loadOneTrust() {
  if (!isEU()) {
    return {};
  }

  await loadScript(
    // Must be kept in sync with onetrust-preload
    "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
    [LibCategories.strictlyNecessary],
    {
      // They appear to support it but this breaks their geolocation API,
      // but in an inconsistent fashion. Disabling as they don't seem to
      // have sufficient QA in CORS mode.
      enableCORS: false,
      htmlAttr: {
        dataset: {
          domainScript: appConfig.ONE_TRUST_DOMAIN_ID,
        },
      },
    }
  );

  // Chaining promise here to allow upstream visibility should the first scrip call fail
  await fullyLoaded;

  return {
    OneTrust: window.OneTrust,
    ActiveGroups: window.OnetrustActiveGroups,
  };
}
